/* BCP Bajaj - bcp-horizon-gift.js  (Horizon theme)
   Cart free-gift progress bar, re-ported from the Dawn version.
   Tier 1: spend Rs.399 -> Free Pachak Sachets 10g x 2  |  Tier 2: spend Rs.799 -> also Free Mukhwas 125g
   Detection is theme-INDEPENDENT: intercepts window.fetch AND XMLHttpRequest to
   /cart/(add|change|update|clear) + listens for Horizon's document cart events + a
   MutationObserver on the cart drawer. Injection target is Horizon's .cart-drawer__content.
   Only touches the two Rs.0 gift variants; never other cart lines. Fully guarded.

   SAFETY (v2): a customer must NEVER be able to check out a gift-only Rs.0 cart.
   - "reconcile" intent is STICKY across coalesced debounce calls, so a drawer
     re-render (MutationObserver -> debounced(false)) can no longer clobber the
     reconcile scheduled by a cart mutation (the old race that stranded a free gift).
   - REMOVING an unqualified gift runs on EVERY refresh (even paint-only), so a gift
     is dropped the moment the qualifying subtotal falls below its tier, no matter how
     the cart changed. ADDING a gift stays gated to intentional cart mutations.
   - Gift lines are removed by their line-item KEY (robust with line properties).
   - Belt-and-suspenders: the checkout + express-checkout buttons are DISABLED whenever
     the cart holds only gift items (qualifying subtotal <= 0), so even if a removal is
     mid-flight or JS is racing, a Rs.0 gift-only order cannot be placed. */
(function () {
  if (window.__bcpHzGift) return;
  window.__bcpHzGift = true;

  var CFG = { tier1: 39900, tier2: 79900, gift1: 52717066223909, gift2: 52716965232933 };
  // The two gift products' own URL handles. Cart rows always link to the product via
  // <a href="/products/{handle}...">, so this is a bullet-proof way to identify a gift
  // line in the rendered cart — independent of the product TITLE (the old detector matched
  // the literal string "(Gift)" in the row text, but neither gift product's title contains
  // it — they are "Gift Unlocked - 1 Free Sachet" and "Free Full-Size Gift Unlocked" — so
  // the qty stepper was never locked and shoppers could edit the free gift's quantity).
  //
  // MUST stay in sync with the products' actual current handle. These were renamed from
  // the original 'free-pachak-sachets-gift' / 'free-mukhwas-gift' to random
  // 'gift-internal-<hex>' handles (see product-form-component lockdown in theme.liquid)
  // so the old, guessable public URLs no longer point at a live product page. That rename
  // silently broke this exact list once already — the row-tagging (and therefore the
  // quantity-hiding CSS) went dark with no error, because giftLinesAll()'s reconciliation
  // safety logic runs on variant_id and doesn't depend on GIFT_HANDLES at all, so nothing
  // about checkout safety looked broken even though the visual fix quietly stopped working.
  var GIFT_HANDLES = ['gift-internal-f9def059449b109e092e', 'gift-internal-508f9bcee3f39a215e41'];
  var ORANGE = '#C8451A', NAVY = '#122154';
  var busy = false, dTimer = null, pendingReconcile = false;

  function fmt(p) { return '₹' + Math.ceil(p / 100).toLocaleString('en-IN'); }
  function checkSVG() { return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'; }
  function giftSVG() { return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#9a9aa8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M12 9v12M3 13h18M12 9C10.5 5 6.5 5.5 7.5 9M12 9c1.5-3.5 5.5-3 4.5 0"/></svg>'; }

  function node(pctPos, amt, name, cls) {
    return '<div class="bcp-hzg-node ' + cls + '" data-th="' + amt + '" style="position:absolute;top:0;left:' + pctPos + '%;transform:translateX(-50%);width:96px;text-align:center;">' +
      '<span class="bcp-hzg-badge" style="display:flex;align-items:center;justify-content:center;width:26px;height:26px;margin:0 auto;border-radius:50%;background:#eceae3;border:2px solid #e0ddd3;box-sizing:border-box;"></span>' +
      '<span style="display:block;margin-top:5px;font-size:.72rem;font-weight:700;color:' + NAVY + ';font-family:var(--font-heading--family,inherit);">' + fmt(amt) + '</span>' +
      '<span style="display:block;font-size:.62rem;color:#6a6a72;line-height:1.15;">' + name + '</span>' +
    '</div>';
  }

  function makeBar() {
    var d = document.createElement('div');
    d.className = 'bcp-hz-gift';
    d.setAttribute('style', 'margin:0 0 14px;padding:12px 14px 12px;border-radius:14px;background:#f6f4ef;border:1px solid #e6e3da;font-family:inherit;box-sizing:border-box;');
    d.innerHTML =
      '<p class="bcp-hzg-title" style="margin:0 0 4px;text-align:center;font-size:.85rem;font-weight:700;color:' + NAVY + ';line-height:1.3;font-family:var(--font-heading--family,inherit);"></p>' +
      '<div class="bcp-hzg-track" style="position:relative;height:62px;margin:6px 30px 0;">' +
        '<div style="position:absolute;left:0;right:0;top:11px;height:4px;background:#e0ddd3;border-radius:4px;"></div>' +
        '<div class="bcp-hzg-fill" style="position:absolute;left:0;top:11px;height:4px;width:100%;transform:scaleX(0);transform-origin:left;background:' + ORANGE + ';border-radius:4px;transition:transform .55s ease;"></div>' +
        node(50, CFG.tier1, 'Free Sachet', 'bcp-hzg-n1') +
        node(100, CFG.tier2, 'Free Full-Size Gift', 'bcp-hzg-n2') +
      '</div>';
    return d;
  }

  // Exactly ONE injection target (outermost cart container), to avoid duplicate bars.
  function pickHost() {
    return document.querySelector('cart-drawer .cart-drawer__content')
        || document.querySelector('.cart-drawer__content')
        || document.querySelector('cart-items-component')
        || null;
  }
  function ensureBars() {
    var host = pickHost();
    var all = document.querySelectorAll('.bcp-hz-gift');
    var kept = null;
    for (var i = 0; i < all.length; i++) {
      if (!kept && host && host.contains(all[i])) { kept = all[i]; }
      else if (all[i].parentNode) { all[i].parentNode.removeChild(all[i]); }
    }
    if (host && !kept) host.insertBefore(makeBar(), host.firstChild);
  }

  function isGift(v) { return v === CFG.gift1 || v === CFG.gift2; }
  function qualifying(cart) {
    var t = 0;
    cart.items.forEach(function (i) { if (!isGift(i.variant_id)) t += i.final_line_price; });
    return t;
  }
  function nonGiftCount(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (!isGift(i.variant_id)) n += i.quantity; });
    return n;
  }
  // Returns EVERY cart line matching variant v, not just the first. Shopify keys line
  // identity on (variant_id, properties) together, not variant_id alone - our own
  // addGift() tags its line with properties:{_gift:'true'}, but a shopper who reaches
  // the gift product's own page directly (see GIFT_HANDLES doc / URL redirect notes)
  // and clicks its native "Add to cart" form adds it with NO properties, which
  // Shopify stores as a SEPARATE, second line for the same variant. The old
  // single-result giftLine() only ever saw one of the two and left the other
  // completely unmanaged - not removed when unqualified, not capped at quantity 1
  // when qualified. That gap is what let extra free units reach checkout.
  function giftLinesAll(cart, v) {
    var out = [];
    for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === v) out.push(cart.items[i]); }
    return out;
  }
  function addGift(v) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v, quantity: 1, properties: { _gift: 'true' } }] }) }); }
  // Remove by line KEY (robust with line properties).
  function removeLine(key) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(key), quantity: 0 }) }); }
  // Force a line to a specific quantity (used to LOCK free gifts to qty 1).
  function setQty(key, qty) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(key), quantity: qty }) }); }

  // Force the cart drawer's DOM to reflect the LIVE server-side cart. Needed both
  // when WE mutate the cart (add/remove/setQty above) and when the shopper's own
  // add-to-cart leaves the drawer showing its stale page-load render.
  //
  // v3 REWRITE: this used to ask Shopify's Section Rendering API to re-render each
  // cart-items-component's own "section" (id read off its data-section-id attribute)
  // and graft the fresh HTML in. That never worked: data-section-id is set to the
  // literal string "cart-drawer-section" (see snippets/cart-drawer.liquid), which is
  // NOT a real registered Shopify section - cart-drawer.liquid is rendered directly
  // from theme.liquid's <body>, never through {% sections %}. Confirmed live: hitting
  // `?sections=cart-drawer-section` on this store returns 200 with a JSON map that
  // simply doesn't contain that key, so `if (!html) continue` silently skipped the
  // graft on every single call - the drawer's item list has never actually been
  // updated by this code, which is the direct cause of BOTH customer-facing bugs:
  // (1) the drawer opens showing "Your cart is empty" under a correctly-progressing
  //     gift bar even though the server-side cart has items (the bar is 100%
  //     client-rendered from /cart.js, so it alone reflected reality); confirmed via
  //     live repro - item_count:1 on the server, 0 `.cart-items__table-row` in the DOM.
  // (2) the free gift's quantity looked editable in the drawer: not because the
  //     lock CSS/JS is wrong (it isn't - confirmed correct on the standalone /cart
  //     page, which Shopify always renders fresh server-side), but because the
  //     drawer never rendered a REAL gift row for that CSS/JS to ever apply to.
  //
  // Fix: stop asking for a "section" that doesn't exist. Fetch the CURRENT page's
  // own URL (which every page renders via the same theme.liquid -> cart-drawer.liquid
  // path, so it always contains an accurate, freshly-computed .cart-drawer__inner),
  // parse it, and graft that fresh .cart-drawer__inner wholesale over the live one -
  // both its class (this is what actually carries the empty/filled `cart-drawer--empty`
  // toggle - a plain innerHTML swap of an inner element would never touch it) and its
  // contents (header badge, item rows, summary, checkout button) in one consistent
  // swap. The <theme-drawer>/<cart-drawer-component> wrapper elements themselves are
  // left untouched (only their child's innerHTML changes), so the dialog's open state
  // and any listeners attached to those outer custom elements survive the graft.
  //
  // Returns a Promise that ALWAYS resolves (never rejects) once the graft attempt is
  // done, so callers can reliably sequence work after it - see the caller in refresh()
  // for why that matters: the graft replaces the checkout button's container too,
  // wiping any disabled/data-bcp-blocked state setCheckoutBlocked() had applied.
  // Racing the two independently could let a stale "unblocked" state win; sequencing
  // paint() (which re-applies setCheckoutBlocked) strictly after this settles avoids
  // that.
  function morphCartDrawer() {
    try {
      var liveInner = document.querySelector('.cart-drawer__inner');
      if (!liveInner) return Promise.resolve();
      return fetch(location.href, { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshInner = doc.querySelector('.cart-drawer__inner');
          if (!freshInner) return;
          liveInner.className = freshInner.className;
          liveInner.innerHTML = freshInner.innerHTML;
          // Freshly-grafted markup is unprocessed by us - re-tag any gift line
          // immediately rather than waiting for the next refresh()/poll cycle.
          markGiftLines();
        })
        .catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  // Tag the free-gift cart lines (their title carries the "(Gift)" suffix) so their
  // quantity stepper can be hidden via CSS - a free gift is always exactly 1.
  //
  // BUG FIX: this used to also match `cart-items-component tr` and the wildcard
  // `[class*="cart-item"]`. The wildcard matches ANY element whose class contains the
  // substring "cart-item" - which "cart-items-component" and "cart-items" themselves
  // satisfy (they start with "cart-item"). That wrapper surrounds EVERY line in the
  // cart, so its textContent always includes "(Gift)" whenever a gift line exists
  // anywhere, tagging the whole wrapper as .bcp-gift-line and hiding the quantity
  // stepper on every line, not just the gift's - which read as "quantity reduction is
  // not allowed" for regular products too. `.cart-items__table-row` is the real,
  // one-per-line-item class Horizon renders (confirmed in snippets/cart-drawer.liquid),
  // so it can't over-match an ancestor the way the wildcard did.
  function markGiftLines() {
    try {
      var sel = 'a[href*="' + GIFT_HANDLES[0] + '"], a[href*="' + GIFT_HANDLES[1] + '"]';
      var rows = document.querySelectorAll('.cart-items__table-row');
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (!r || !r.classList || r.classList.contains('bcp-gift-line')) continue;
        // Match by the gift products' own URL handles in any link inside the row (robust;
        // see GIFT_HANDLES note above for why the old "(Gift)" text match never fired).
        if (r.querySelector(sel)) {
          r.classList.add('bcp-gift-line');
        }
      }
    } catch (e) {}
  }

  // One-time CSS: remove the quantity control from a gift line entirely - a free gift
  // is always exactly 1, so a non-interactive box that just sits there showing "1"
  // forever adds nothing and reads as broken if a shopper tries to tap it. Confirmed
  // live (see .cart-items__quantity-controls in the DOM tree) that the quantity
  // stepper lives in its own child wrapper INSIDE the row's .cart-items__quantity
  // <td> - hiding that wrapper (not the <td> itself) empties the cell without
  // collapsing it, so every row's columns (price, remove, etc.) stay aligned with
  // the regular product lines above/below it in the same table.
  function injectGiftCSS() {
    if (document.getElementById('bcp-gift-css')) return;
    var s = document.createElement('style');
    s.id = 'bcp-gift-css';
    s.textContent =
      '.bcp-gift-line .cart-items__quantity-controls{display:none !important;}' +
      // The reward is auto-managed by the progress bar, so hide the per-line remove (trash)
      // button on gift lines — the shopper removes it only by dropping below its tier.
      '.bcp-gift-line .cart-items__remove{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  // Disable checkout whenever the cart is gifts-only (qualifying subtotal <= 0 but
  // items exist). Covers the standard checkout button + accelerated/express buttons.
  function setCheckoutBlocked(blocked) {
    var btns = document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart-drawer__checkout, a[href="/checkout"], a[href^="/checkout?"], a[href^="/checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (blocked) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); b.style.opacity = '.45'; b.style.pointerEvents = 'none'; b.setAttribute('data-bcp-blocked', '1'); }
      else if (b.getAttribute('data-bcp-blocked')) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); b.style.opacity = ''; b.style.pointerEvents = ''; b.removeAttribute('data-bcp-blocked'); }
    }
    var xp = document.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, [class*="dynamic-checkout"]');
    for (var j = 0; j < xp.length; j++) {
      var c = xp[j];
      if (blocked) { c.style.display = 'none'; c.setAttribute('data-bcp-blocked', '1'); }
      else if (c.getAttribute('data-bcp-blocked')) { c.style.display = ''; c.removeAttribute('data-bcp-blocked'); }
    }
  }

  function paint(q, onlyGifts) {
    ensureBars();
    markGiftLines();
    var ratio = Math.max(0, Math.min(1, q / CFG.tier2));
    var title = onlyGifts
      ? 'Add a product to your cart to check out 🛒'
      : q < CFG.tier1
        ? 'Add <b>' + fmt(CFG.tier1 - q) + '</b> to unlock a free gift 🎁'
        : q < CFG.tier2
          ? '🎉 Free Sachet unlocked! Add <b>' + fmt(CFG.tier2 - q) + '</b> to upgrade to a Free Full-Size Gift'
          : '🎉 You unlocked your Free Full-Size Gift — on us!';
    document.querySelectorAll('.bcp-hz-gift').forEach(function (bar) {
      var t = bar.querySelector('.bcp-hzg-title'); if (t) t.innerHTML = title;
      var f = bar.querySelector('.bcp-hzg-fill'); if (f) f.style.transform = 'scaleX(' + ratio + ')';
      bar.querySelectorAll('.bcp-hzg-node').forEach(function (n) {
        var th = +n.getAttribute('data-th');
        var badge = n.querySelector('.bcp-hzg-badge');
        if (!badge) return;
        if (q >= th) { badge.style.background = NAVY; badge.style.borderColor = NAVY; badge.innerHTML = checkSVG(); }
        else { badge.style.background = '#eceae3'; badge.style.borderColor = '#e0ddd3'; badge.innerHTML = giftSVG(); }
      });
    });
    setCheckoutBlocked(onlyGifts);
  }

  function refresh(reconcile) {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var q = qualifying(cart);
      var onlyGifts = nonGiftCount(cart) === 0 && cart.items.length > 0;
      paint(q, onlyGifts);

      // EXACTLY ONE free gift, ever (the two tiers are mutually exclusive, not additive):
      //   q < tier1        -> no gift
      //   tier1 <= q < tier2 -> Sachets (gift1) only
      //   q >= tier2       -> Mukhwas (gift2) only; it REPLACES the Sachets (upgrade)
      // want1 and want2 can never both be true, so a cart should hold at most one gift
      // line - "should", because a shopper can create a SECOND, separate line for the
      // same gift variant by adding it with no line properties (see giftLinesAll doc),
      // which the checks below now account for.
      var acts = [];
      var l1all = giftLinesAll(cart, CFG.gift1), l2all = giftLinesAll(cart, CFG.gift2);
      var l1 = l1all[0] || null, l2 = l2all[0] || null;
      var want1 = q >= CFG.tier1 && q < CFG.tier2;
      var want2 = q >= CFG.tier2;
      // REMOVE every line for a gift that isn't the one currently earned, on EVERY
      // refresh (safety) - ALL matching lines, not just the first. This is what drops
      // the Sachets the moment the cart crosses tier2, so the shopper is left with only
      // the Mukhwas, and what catches a manually-added duplicate line that isn't
      // actually earned at all.
      if (!want1) { l1all.forEach(function (l) { acts.push(removeLine(l.key)); }); }
      if (!want2) { l2all.forEach(function (l) { acts.push(removeLine(l.key)); }); }
      // Free gift is ALWAYS exactly ONE line at qty 1 - collapse any extra duplicate
      // lines for the earned gift (keep the first, drop the rest) and snap the survivor
      // back to quantity 1. Guarded to the gift that is actually wanted, so we never
      // fight the remove above on the same line key.
      if (want1) {
        for (var di = 1; di < l1all.length; di++) acts.push(removeLine(l1all[di].key));
        if (l1 && l1.quantity > 1) acts.push(setQty(l1.key, 1));
      }
      if (want2) {
        for (var dj = 1; dj < l2all.length; dj++) acts.push(removeLine(l2all[dj].key));
        if (l2 && l2.quantity > 1) acts.push(setQty(l2.key, 1));
      }
      // ADD the earned gift (only on reconcile, so a gift a shopper manually deleted
      // isn't force-re-added on a paint-only refresh).
      if (reconcile) {
        if (want1 && !l1) acts.push(addGift(CFG.gift1));
        if (want2 && !l2) acts.push(addGift(CFG.gift2));
      }

      // Detect the drawer showing stale content relative to the real cart - the bug
      // this whole rewrite targets (see morphCartDrawer doc). This fires even when
      // acts is empty (a plain product add that doesn't touch a gift line), which is
      // exactly the case that used to slip through: nothing for THIS script to mutate,
      // so the old code never even tried to refresh the drawer's item list.
      // Signal is JUST the empty/filled class mismatch, not a row-count comparison:
      // Horizon renders an extra non-product decorative row in .cart-items__table-row
      // (confirmed live), so "row count === item count" is never reliably true and
      // would make this fire on every single refresh - wastefully re-morphing (and
      // briefly flashing) a drawer that's already correct.
      var innerEl = document.querySelector('.cart-drawer__inner');
      var domStale = !!innerEl && cart.items.length > 0 && innerEl.classList.contains('cart-drawer--empty');

      if (acts.length) {
        // MUST-FIX: busy stays true for the WHOLE tail (morph -> refetch -> paint), not
        // just until the mutations above resolve. The morph/refetch round-trip takes
        // real wall-clock time (a full-page fetch, then a /cart.js fetch); releasing
        // busy before that tail starts let the MutationObserver's own debounced(false)
        // (triggered by the graft's own DOM mutation) or the 1.5s poll race a SECOND,
        // independent refresh() against this one - which could finish its own
        // paint()/setCheckoutBlocked() before this chain's later morph clobbers it
        // again with no follow-up paint to fix it. Keeping busy true makes any
        // concurrent refresh() attempt during this window return early instead.
        Promise.all(acts).then(function () {
          if (location.pathname.indexOf('/cart') === 0) { busy = false; location.reload(); return; }
          // Sequenced (not fire-and-forget): the graft replaces the checkout button's
          // container too, so paint()'s setCheckoutBlocked() must run AFTER it settles,
          // never race it - otherwise a freshly-grafted (unblocked) button could win
          // and briefly leave checkout clickable on a gifts-only cart.
          return morphCartDrawer().then(function () {
            return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
          }).then(function (c2) {
            paint(qualifying(c2), nonGiftCount(c2) === 0 && c2.items.length > 0);
          }).then(function () { busy = false; });
        }).catch(function () { busy = false; });
        return;
      }
      if (domStale) {
        // The morph replaces .cart-drawer__inner's innerHTML with a fresh server
        // render, which naturally doesn't include our client-injected .bcp-hz-gift
        // bar - repaint with the q/onlyGifts already computed above (the cart itself
        // hasn't changed, only its DOM was stale) to reinsert it and re-tag the gift
        // line on the freshly-grafted rows.
        // MUST have a .catch(): without one, an error anywhere in this chain (e.g. a
        // DOM assumption inside paint() failing on some unexpected markup) rejects
        // silently and never resets busy - permanently wedging the ENTIRE script,
        // including the gifts-only-cart checkout-block safety net, since refresh()'s
        // very first line is `if (busy) return`.
        morphCartDrawer().then(function () { paint(q, onlyGifts); busy = false; }).catch(function () { busy = false; });
        return;
      }
      busy = false;
    }).catch(function () { busy = false; });
  }

  // STICKY reconcile: once any coalesced call requests reconcile=true, the debounced
  // run keeps it true even if a later debounced(false) (e.g. drawer re-render) arrives.
  function debounced(reconcile) {
    if (reconcile) pendingReconcile = true;
    clearTimeout(dTimer);
    dTimer = setTimeout(function () { var r = pendingReconcile; pendingReconcile = false; refresh(r); }, 200);
  }

  function isCartUrl(u) { return /\/cart\/(add|change|update|clear)/.test(u); }

  // Intercept fetch.
  var of = window.fetch;
  window.fetch = function () {
    var u = arguments[0] ? String(arguments[0]) : '';
    var p = of.apply(this, arguments);
    if (isCartUrl(u)) { p.then(function () { debounced(true); }); }
    return p;
  };

  // Intercept XMLHttpRequest (some cart controls use XHR, which the fetch hook misses).
  try {
    var oOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__bcpCart = isCartUrl(String(url || '')); } catch (e) {}
      return oOpen.apply(this, arguments);
    };
    var oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__bcpCart) { this.addEventListener('loadend', function () { debounced(true); }); }
      return oSend.apply(this, arguments);
    };
  } catch (e) {}

  ['cart:lines:update', 'cart:update', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { debounced(false); });
  });

  function boot() { injectGiftCSS(); ensureBars(); refresh(true); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);

  // Meta/Instagram in-app browsers aggressively cache pages (bfcache) and GET responses.
  // When a shopper taps the ad, lands, adds an item, then the page is restored from cache
  // (or /cart.js was served stale), the bar could show the empty-cart 'Add ₹399' state even
  // though the cart has an item. no-store on the cart reads above prevents the stale read;
  // this re-syncs on bfcache restore as a belt-and-suspenders.
  window.addEventListener('pageshow', function (e) { if (e.persisted) debounced(true); });

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tg = muts[i].target;
        if (!tg || !tg.closest) continue;
        if (tg.closest('.bcp-hz-gift')) continue;
        if (tg.closest('.cart-drawer__content, cart-drawer-component, cart-items-component, [class*="cart-items"], dialog')) {
          debounced(false);
          return;
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[href="/cart"], [href$="/cart"], cart-icon, .cart-icon, [class*="cart-toggle"], [aria-controls*="cart" i]')) {
      setTimeout(function () { debounced(false); }, 350);
    }
  });

  // Robust sync: quantity changes inside the drawer/page can bypass the fetch/XHR
  // hooks and childList mutations above. Poll and reconcile (idempotent - no acts,
  // and now no morph either, once domStale is false) so the bar + gifts + drawer
  // content always track the cart WITHOUT a manual refresh, in both places a shopper
  // can change quantity: the cart drawer (while open) AND the standalone /cart page
  // (which has no dialog to gate on — this was previously unpolled, so a qty edit
  // there silently drifted the gift out of sync until a full page reload).
  try {
    var isCartPage = /^\/cart\/?$/.test(location.pathname);
    setInterval(function () {
      var dlg = document.querySelector('#cart-drawer dialog, cart-drawer-component dialog, cart-drawer dialog, dialog[aria-labelledby*="cart" i]');
      var drawerOpen = dlg && (dlg.open || dlg.hasAttribute('open') || dlg.getAttribute('aria-hidden') === 'false');
      if (drawerOpen || isCartPage) debounced(true);
    }, 1500);
  } catch (e) {}
})();
